import clsx from 'clsx'
import { Button } from './Button'
import type { ButtonGroupProps } from './types'
import { Menu } from '../Menu'
import { checkIsMenu } from '../Menu/checkisMenu'

export function ButtonGroup({ buttons, size, compact }: ButtonGroupProps) {
  return (
    <div
      className={clsx('flex', {
        'gap-x-2': !compact,
      })}
    >
      {buttons
        .filter(
          (button) =>
            (checkIsMenu(button) && button.items.length > 0) ||
            !checkIsMenu(button),
        )
        .map((button, idx, arr) => {
          const classes = clsx(button.className, {
            'rounded-none border-x-0 border-l': compact,
            'border-r rounded-r-lg': idx === arr.length - 1,
            'rounded-l-lg': idx === 0,
          })
          if (checkIsMenu(button)) {
            return (
              <Menu
                {...button}
                trigger={{
                  ...button.trigger,
                  size,
                  className: classes,
                }}
              />
            )
          }

          return (
            <Button
              key={`label-group-${button.label}`}
              {...button}
              size={size}
              className={classes}
            />
          )
        })}
    </div>
  )
}
